import useTLO from "./useTLO"

export default function useSale(id) {
  return useTLO("sale", id)
}
